export const features = [
  {
    id: "f1",
    icon: "ri-rocket-2-line",
    title: "极速部署",
    description: "hlw 采用先进的容器化技术，实现分钟级部署上线。无论是小型项目还是大型企业级应用，都能在最短时间内完成配置并投入使用，大幅缩短产品上线周期。",
  },
  {
    id: "f2",
    icon: "ri-shield-check-line",
    title: "安全可靠",
    description: "多层安全防护体系覆盖数据传输、存储和访问全链路。采用国密标准加密算法，通过 ISO 27001 认证，为您的业务数据提供银行级安全保障。",
  },
  {
    id: "f3",
    icon: "ri-bar-chart-grouped-line",
    title: "智能分析",
    description: "内置强大的数据分析引擎，实时监控业务指标变化。通过 AI 算法自动识别异常波动，并提供可操作的优化建议，帮助您做出更精准的决策。",
  },
  {
    id: "f4",
    icon: "ri-git-branch-line",
    title: "灵活扩展",
    description: "开放的 API 接口和丰富的插件生态，支持与现有系统无缝对接。模块化架构设计让您可以根据业务发展阶段灵活增减功能模块。",
  },
  {
    id: "f5",
    icon: "ri-customer-service-2-line",
    title: "专业支持",
    description: "7×24 小时全天候技术支持服务，平均响应时间不超过 5 分钟。专属客户成功经理全程跟进，确保您的每一个问题都能得到及时有效的解决。",
  },
  {
    id: "f6",
    icon: "ri-global-line",
    title: "多端适配",
    description: "一次开发，多端运行。完美适配 PC、平板、手机等各类终端设备，自动响应不同屏幕尺寸，为用户提供一致流畅的使用体验。",
  },
];

export const advantages = [
  {
    id: "a1",
    title: "高效省时",
    value: "85%",
    description: "相比传统方案，项目交付周期平均缩短 85%。自动化流程取代繁琐的手工操作，让团队将更多精力聚焦于核心业务创新。",
  },
  {
    id: "a2",
    title: "降低成本",
    value: "60%",
    description: "灵活的按需付费模式搭配资源智能调度，帮助企业减少 60% 的 IT 基础设施投入，同时提升资源利用率至 90% 以上。",
  },
  {
    id: "a3",
    title: "品质保障",
    value: "99.9%",
    description: "服务可用性承诺达到 99.9%，全年故障时间不超过 8.76 小时。多层次容灾备份机制确保业务连续不中断。",
  },
  {
    id: "a4",
    title: "用户满意",
    value: "98%",
    description: "累计服务超过 10,000 家企业客户，客户满意度持续保持在 98% 以上。口碑推荐率达 75%，是行业平均水平的 3 倍。",
  },
];

export const scenarios = [
  {
    id: "s1",
    icon: "ri-store-2-line",
    title: "电商零售",
    description: "为电商企业提供高性能的商品管理、订单处理和用户运营解决方案。支持高并发场景下的稳定运行，助力双十一等大促活动平稳度过。",
    image: "https://readdy.ai/api/search-image?query=Modern%20ecommerce%20technology%20platform%20with%20minimalist%20digital%20interface%20showing%20product%20management%20dashboard%2C%20warm%20white%20and%20beige%20background%2C%20clean%20professional%20design%2C%20soft%20lighting&width=800&height=500&seq=scenario-ecommerce&orientation=landscape",
  },
  {
    id: "s2",
    icon: "ri-building-2-line",
    title: "企业服务",
    description: "面向中大型企业提供定制化的数字化管理平台，涵盖人事管理、财务审批、项目协作等核心模块，助力企业实现全面的数字化转型。",
    image: "https://readdy.ai/api/search-image?query=Modern%20enterprise%20digital%20management%20platform%20dashboard%20interface%2C%20minimalist%20corporate%20design%2C%20clean%20white%20and%20warm%20beige%20background%2C%20professional%20atmosphere%2C%20soft%20lighting%2C%20high%20detail&width=800&height=500&seq=scenario-enterprise&orientation=landscape",
  },
  {
    id: "s3",
    icon: "ri-graduation-cap-line",
    title: "在线教育",
    description: "为教育机构和知识付费平台搭建直播授课、课程管理、学员互动等一体化系统。支持万人同时在线学习，保障流畅的教学体验。",
    image: "https://readdy.ai/api/search-image?query=Modern%20online%20education%20learning%20platform%20interface%20with%20minimalist%20design%2C%20warm%20white%20and%20beige%20tones%2C%20clean%20dashboard%20showing%20courses%20and%20progress%2C%20soft%20professional%20lighting&width=800&height=500&seq=scenario-education&orientation=landscape",
  },
  {
    id: "s4",
    icon: "ri-heart-pulse-line",
    title: "医疗健康",
    description: "为医疗机构打造合规安全的患者管理系统、在线问诊平台和健康数据追踪工具。严格遵循医疗行业数据安全标准，保障患者隐私。",
    image: "https://readdy.ai/api/search-image?query=Modern%20healthcare%20digital%20platform%20interface%20with%20minimalist%20medical%20design%2C%20clean%20white%20and%20soft%20green%20accents%2C%20patient%20management%20dashboard%2C%20professional%20medical%20atmosphere%2C%20soft%20lighting&width=800&height=500&seq=scenario-healthcare&orientation=landscape",
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "张明华",
    title: "某知名电商企业 CTO",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%20in%20modern%20office%20setting%2C%20warm%20professional%20photography%2C%20clean%20white%20background%2C%20friendly%20confident%20expression%2C%20corporate%20headshot%20style&width=120&height=120&seq=avatar-zhang&orientation=squarish",
    content: "使用 hlw 平台后，我们的技术团队从繁重的运维工作中解放出来，产品迭代速度提升了 3 倍。hlw 的智能分析功能帮助我们及时发现并优化了多个性能瓶颈，用户体验显著改善。",
    rating: 5,
    company: "速达电商",
    date: "2026年3月",
  },
  {
    id: "t2",
    name: "李思涵",
    title: "某教育科技公司 CEO",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%20in%20modern%20office%2C%20warm%20natural%20light%2C%20clean%20white%20background%2C%20confident%20professional%20expression%2C%20corporate%20headshot&width=120&height=120&seq=avatar-li&orientation=squarish",
    content: "hlw 平台帮助我们在一周内就完成了在线教育系统的搭建，这在以前至少需要两个月的开发周期。学员端的体验非常流畅，家长反馈也很好。专业支持团队的响应速度令人印象深刻。",
    rating: 5,
    company: "智学在线",
    date: "2026年5月",
  },
  {
    id: "t3",
    name: "王建国",
    title: "某金融机构技术总监",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20middle%20aged%20man%20business%20portrait%2C%20modern%20office%20background%2C%20warm%20lighting%2C%20clean%20composition%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-wang&orientation=squarish",
    content: "作为金融行业从业者，我们对数据安全和系统稳定性有极高的要求。hlw 平台的安全防护体系完全满足监管要求，99.9% 的可用性承诺在实际运营中得到了充分验证。",
    rating: 5,
    company: "金汇科技",
    date: "2026年4月",
  },
  {
    id: "t4",
    name: "陈晓芳",
    title: "某零售连锁 CIO",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%2C%20modern%20minimalist%20office%20setting%2C%20warm%20natural%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-chen&orientation=squarish",
    content: "hlw 的灵活扩展能力让我们能够随着门店扩张逐步增加功能模块，避免了传统方案大而全造成资源浪费的问题。按需付费的模式让 IT 预算更加可控。",
    rating: 5,
    company: "美佳连锁",
    date: "2026年6月",
  },
  {
    id: "t5",
    name: "刘浩然",
    title: "独立开发者",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20young%20Chinese%20man%20portrait%20in%20creative%20workspace%2C%20warm%20lighting%2C%20clean%20modern%20style%2C%20friendly%20expression%2C%20professional%20headshot&width=120&height=120&seq=avatar-liu&orientation=squarish",
    content: "作为独立开发者，hlw 让我能够一个人完成过去需要一个团队才能做的事情。极速部署功能尤其好用，从写好代码到上线只需要几分钟，开发效率大幅提升。",
    rating: 5,
    company: "自由职业",
    date: "2026年7月",
  },
  {
    id: "t6",
    name: "赵雪莹",
    title: "某医疗科技产品经理",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20in%20modern%20office%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20confident%20expression&width=120&height=120&seq=avatar-zhao&orientation=squarish",
    content: "医疗行业对合规要求非常严格，hlw 平台在数据安全方面的设计让我们在合规审查中顺利通过。平台内置的数据加密和访问控制功能完全满足 HIPAA 等国际标准的合规要求。",
    rating: 5,
    company: "康健医疗科技",
    date: "2026年2月",
  },
];